import State from '../core/State';
import Agent from '../entity/Agent';
import initialState from '../initialState';

export const storeCurrentAgent = (currentAgent: {
  id: string;
  comment: string;
  name: string;
  permissions: { action: string; permission: boolean }[];
}) => (state: State): State => ({
  ...state,
  currentAgent,
});

export const storeAgentMemberships = (agentMemberships: {
  nodes: {
    agent: Agent;
    id: string;
    roleNames: string[];
    user: {
      id: string;
      name: string;
      profileImageUrl: string;
    };
  }[];
  pageInfo: {
    endCursor: string;
    startCursor: string;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
}) => (state: State): State => ({
  ...state,
  agentMemberships,
});

export const storeUpdateAgentMembership = (agentMembership: {
  agent: Agent | null;
  id: string;
  roleNames: string[];
  user: {
    id: string;
    name: string;
    profileImageUrl: string;
  };
}) => (state: State): State => {
  state.agentMemberships.nodes = state.agentMemberships.nodes.map(item =>
    item?.user?.id === agentMembership.user.id ? agentMembership : item,
  );
  return {
    ...state,
  };
};

export const storeAgentInvitation = (agentInvitation: {
  agent: Agent;
  enabled: boolean;
  id: string;
  token: string;
}) => (state: State): State => ({
  ...state,
  agentInvitation,
});

export const storeDeleteAgentMembership = (deleteAgentMembership: { id: string; clientMutationId?: string }) => (
  state: State,
): State => {
  state.agentMemberships.nodes = state.agentMemberships.nodes.filter(item => item?.id !== deleteAgentMembership.id);
  return {
    ...state,
  };
};

export const disposeAgent = () => (state: State): State => ({
  ...state,
  currentAgent: initialState.currentAgent,
  agentMemberships: initialState.agentMemberships,
  agentInvitation: initialState.agentInvitation,
});
